import { Table as AntdTable, TablePaginationConfig, TableProps } from 'antd';
import { ReactElement } from 'react';
import { ChevronDoubleLeft, ChevronDoubleRight, ChevronLeft, ChevronRight, ThreeDots } from 'react-bootstrap-icons';

interface Props<RecordType> extends Omit<TableProps<RecordType>, 'pagination'> {
  pagination?: false | Omit<
    TablePaginationConfig,
    | 'nextIcon'
    | 'prevIcon'
    | 'jumpNextIcon'
    | 'jumpPrevIcon'
    | 'size'
    | 'itemRender'
    | 'showTotal'
  >
}

export const AppTable: <RecordType extends object>(props: Props<RecordType>) => ReactElement<Props<RecordType>> = ({
  ...tableProps
}) => {
  return (
    <AntdTable
      { ...tableProps }
      pagination={{
        ...tableProps.pagination,
        size: 'default',
        showTotal: (total, range) => `${ range[0] }-${ range[1] } з ${ total }`,
        itemRender: (_, type, element) => {
          if (type === 'page') return element;
          return (
            <div id={ type } className="ant-pagination-item-link">
              <div className="ant-pagination-item-container">
                <div className="ant-pagination-item-link-icon" style={{ fontSize: 16, width: 18 }}>
                  { element }
                </div>
                {
                  type === 'jump-next' || type === 'jump-prev'
                    ? <div className="ant-pagination-item-ellipsis">
                      <ThreeDots size={ 20 }/>
                    </div>
                    : ''
                }
              </div>
            </div>
          );
        },
        nextIcon: <ChevronRight size={ 14 }/>,
        prevIcon: <ChevronLeft size={ 14 }/>,
        jumpNextIcon: <ChevronDoubleRight size={ 14 }/>,
        jumpPrevIcon: <ChevronDoubleLeft size={ 14 }/>,
      }}
    />
  );
};
